import { render } from "./ClinicalLabDetailComponent.vue?vue&type=template&id=7337b239&scoped=true"
import script from "./ClinicalLabDetailComponent.vue?vue&type=script&lang=js"
export * from "./ClinicalLabDetailComponent.vue?vue&type=script&lang=js"

import "./ClinicalLabDetailComponent.vue?vue&type=style&index=0&id=7337b239&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7337b239"]])

export default __exports__